import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';
import "w3-css/3/w3.css";
import "./Volume.css";
import {
  FromCubicFootButton,
  FromCubicInchButton,
  FromCubicMeterButton,
  FromCubicMileButton,
  FromCubicYardButton,
  FromLiterButton
} from "./Button";
import { getConversion } from "./volume/ConversionTracker";
import { trackConversion, trackButtonClick } from "../../utils/analytics";
export default class Volumes extends Component {
  render() {
    return (
      <div>
      <Helmet>
        <title>Free Volume Converter - Convert Liters, Gallons, Cubic Feet & More | Kayannou</title>
        <meta name="description"
          content="Free online volume converter. Convert between liters, gallons, cubic feet, cubic meters, cubic inches, cubic yards, and cubic miles. Fast, accurate, and easy-to-use volume conversion tool." />
        <meta name="keywords"
          content="volume converter, volume conversion, liters to gallons, cubic feet converter, volume calculator, unit converter, convert volume, free volume converter, online volume tool, cubic foot, cubic inch, cubic meter, cubic mile, cubic yard, liter, gallon" />
        <meta name="author" content="Kayannou" />
        <meta property="og:title" content="Free Volume Converter - Convert Liters, Gallons, Cubic Feet & More" />
        <meta property="og:description" content="Free online volume converter. Convert between liters, gallons, cubic feet, and more. Fast and accurate." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Free Volume Converter - Convert Liters, Gallons, Cubic Feet & More" />
        <meta name="twitter:description" content="Free online volume converter. Convert between liters, gallons, cubic feet, and more." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Volume Converter",
            "description": "Free online volume converter for liters, gallons, cubic feet, and more",
            "url": "https://kayannou.com/conversion/volume",
            "applicationCategory": "UtilityApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            }
          })}
        </script>
      </Helmet>
      <Container />
        </div >
    );
  }
}
class Container extends Component {
  state = {
    value: "",
    operation: ""
  };
  handleConversionButton = buttonId => {
    this.setState({ operation: buttonId });
    // Track button click
    trackButtonClick(`Volume: ${buttonId}`, 'Volume Conversion');
  };

  handleConversionValue = inputValue => {
    this.setState({ value: inputValue });
    // Track conversion when both value and operation are present
    if (inputValue && this.state.operation) {
      trackConversion('Volume', this.state.operation, 'multiple_units', inputValue);
    }
  };

  render() {
    return (
      <div className="volume-conversion-container">
        <div className="conversion-content">
          <ContainerHeader
            conversionValue={this.handleConversionValue}
            conversionresult={getConversion(
              this.state.value,
              this.state.operation
            )}
          />
          <MiddleColumn id="" conversionButton={this.handleConversionButton} />
        </div>
      </div>
    );
  }
}
class ContainerHeader extends Component {
  state = {
    inputValue: "",
    isFocused: false
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.conversionValue(value);
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  clearInput = () => {
    this.setState({ inputValue: "" });
    this.props.conversionValue("");
    if (this.input) {
      this.input.focus();
    }
  };

  render() {
    let result = this.props.conversionresult;
    const { inputValue, isFocused } = this.state;

    return (
      <div className="conversion-header">
        <div className="conversion-container">
          {/* Input Section */}
          <div className="input-section">
            <div className="input-group">
              <label className="input-label">
                <i className="fa fa-cube"></i>
                Volume Input
              </label>
              <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${inputValue ? 'has-value' : ''}`}>
                <input
                  ref={input => (this.input = input)}
                  className="conversion-input"
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  value={inputValue}
                  name="volume"
                  type="number"
                  placeholder="Enter volume conversion..."
                  min="0"
                  step="any"
                />
                {inputValue && (
                  <button
                    className="clear-button"
                    onClick={this.clearInput}
                    type="button"
                    aria-label="Clear input"
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
                <div className="input-border"></div>
              </div>
            </div>
          </div>

          {/* Result Section */}
          <div className="result-section">
            <div className="result-group">
              <label className="result-label">
                <i className="fa fa-calculator"></i>
                Conversion Result
              </label>
              <div className="result-display">
                {result ? (
                  <div className="result-content">
                    <span className="result-value">{result}</span>
                    <div className="result-indicator">
                      <i className="fa fa-check-circle"></i>
                    </div>
                  </div>
                ) : (
                  <div className="result-placeholder">
                    <i className="fa fa-arrow-left"></i>
                    <span>Enter value and select type</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Visual Enhancement */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="decoration-line"></div>
        </div>
      </div>
    );
  }
}
class MiddleColumn extends Component {
  handleClickUnit = buttonId => {
    this.props.conversionButton(buttonId);
  };

  render() {
    return (
      <div className="conversion-buttons-section">
        <div className="buttons-header">
          <h3 className="section-title">
            <i className="fa fa-cube"></i>
            Select Conversion Type
          </h3>
          <p className="section-description">
            Choose the volume unit you want to convert from
          </p>
        </div>

        <div className="conversion-buttons-grid">
          <FromCubicFootButton id="ftto" ftUnit={this.handleClickUnit} />
          <FromCubicInchButton id="into" inUnit={this.handleClickUnit} />
          <FromCubicMeterButton id="mto" mUnit={this.handleClickUnit} />
          <FromCubicMileButton id="mito" miUnit={this.handleClickUnit} />
          <FromCubicYardButton id="ydto" ydUnit={this.handleClickUnit} />
          <FromLiterButton id="lto" lUnit={this.handleClickUnit} />
        </div>
      </div>
    );
  }
}
